/**
 * List of experiments that should be enabled for the widget. Experiments
 * listed here are meant to modify the widget's params with its properties object.
 *
 * For example:
 * - 3_seconds_carousel_a_b_test: { autoplay_duration: '3', autoplay_loop: 'false' }
 */
export const WIDGET_EXPERIMENTS = ['3_seconds_carousel_a_b_test'] as const
